import { ArrowRight, MapPin } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { scrollToHash } from "../components/Navbar";

export const Hero = () => (
    <section id="home" data-testid="hero-section" className="bg-white pt-[72px]">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-16 sm:px-8 sm:py-20 lg:grid-cols-2 lg:gap-16 lg:py-28">
            <Reveal>
                <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark">
                    <span className="h-px w-8 bg-gold" aria-hidden="true" />
                    Wholesale &amp; Retail — United Kingdom
                </span>
                <h1 className="mt-6 font-heading text-4xl font-extrabold leading-[1.12] tracking-tight text-navy-900 sm:text-5xl lg:text-6xl">
                    Wholesale &amp; Retail Products, Built Around Reliability
                </h1>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
                    PISI LIMITED supplies a broad range of everyday consumer goods, groceries,
                    beverages, household products and general retail products to customers and
                    businesses.
                </p>
                <div className="mt-9 flex flex-wrap items-center gap-4">
                    <button
                        type="button"
                        data-testid="hero-cta-products"
                        onClick={() => scrollToHash("#products")}
                        className="group inline-flex items-center gap-2 bg-navy-900 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-navy-800"
                    >
                        Explore Our Products
                        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
                    </button>
                    <button
                        type="button"
                        data-testid="hero-cta-enquire"
                        onClick={() => scrollToHash("#contact")}
                        className="inline-flex items-center gap-2 border border-navy-900 px-7 py-3.5 text-sm font-semibold text-navy-900 transition-colors duration-200 hover:bg-navy-900 hover:text-white"
                    >
                        Contact Us
                    </button>
                </div>
                <p className="mt-8 flex items-center gap-2 text-sm text-slate-500">
                    <MapPin className="h-4 w-4 text-gold-dark" />
                    Based in Croydon, United Kingdom
                </p>
            </Reveal>

            <Reveal delay={150} className="relative">
                <div
                    className="absolute -left-4 -top-4 hidden h-full w-full border border-gold/50 sm:block"
                    aria-hidden="true"
                />
                <img
                    src="/images/hero-warehouse.jpg"
                    alt="Shop owner at the counter of an independent UK retail store"
                    data-testid="hero-image"
                    className="hero-image-frame relative h-[320px] w-full object-cover sm:h-[440px] lg:h-[540px]"
                    loading="eager"
                />
            </Reveal>
        </div>
    </section>
);
